@if (naytettavaKirjausObservable | async; as valittuKirjaus) {
  @if (naytettavatTositteetJaSivutObservable | async; as naytettavatTositteetJaSivut) {
    <div style="display: flex; height: calc(100vh - 40px); flex-direction: column; flex-grow: 1" [class.sivuja]="naytettavatTositteetJaSivut.length">
      <div #mainDiv class="tositteet-container">
        <div app-kirjanpito-tosite-naytto [isMainEnhancedOn]="isMainEnhancedOn" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut" [scrollContainerRef]="mainDivRef" [naytettavaKirjausObservable]="naytettavaKirjausObservable"></div>
        <div class="kirjauksen-tositteet-drop-area" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <app-icon-button (click)="lisaaTiedostoja()" actionId="Valitse tiedosto: Lisää tiedostoja kirjanpitoon" additionalClass="drop-button" matIcon="add"> </app-icon-button>
          <div class="drop-text">Lisää uusi tosite plus-merkistä tai raahaa se tähän</div>
        </div>
        <div class="kirjauksen-tositteet-drop-area-initally-hidden" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <div class="drop-text">Pudota tiedosto tähän</div>
          <i class="drop-here-icon fa fa-arrow-down"></i>
        </div>
      </div>
    </div>
  } @else {
    <div class="kirjauksen-tositteet-ladataan-metadataa">
      <div style="margin-bottom: 1em">Ladataan kirjaukseen liitettyjen tositteiden tietoja</div>
      <mat-progress-bar mode="indeterminate" style="margin: 20px 0; width: calc(100% - 40px)"></mat-progress-bar>
    </div>
  }
} @else {
  <div class="kirjauksen-tositteet-ei-valittua">
    <div><span class="virhe-teksti">Virhe!&nbsp;</span>Valitse kirjaus</div>
  </div>
}

<input style="visibility: hidden; height: 1px; position: absolute; left: -9999px" (change)="fileChanged($event)" type="file" accept="image/*,application/pdf" #fileInput multiple="multiple" />
